import Header from 'component/common/header/Header';

import Footer from 'component/common/footer/Footer';
import TopBtn from 'component/common/button/top/TopBtn';

import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ApiBookWriterIntroNew } from 'api/Book';
import { ImgBadge } from 'utils/Images';

import style from './style/Contents.module.scss';
import { useIsMobile } from 'utils/Common';
import { useMemberInfo } from 'utils/State';
import { getViewCntConvert } from 'utils/Common';
import BookpalLink, { useBookpalNavigate } from 'component/common/custom/BookpalLink';
import BookpalLazyLoadImage from 'component/common/custom/BookpalLazyLoadImage';


function ContentsWriter(){

    const isMobile = useIsMobile();

    const memberInfo = useMemberInfo();

    const navigate = useBookpalNavigate();

    const [info, setInfo] = useState(null);
    const [name, setName] = useState(null);
    const [isEmpty, setIsEmpty] = useState(false);

    const { type, bid } = useParams();

    const contentRef = useRef();

    const [data, dataSubmit, initData, paging, setData] = ApiBookWriterIntroNew({
        data:{
            bid:bid,
        },
        onSuccess:(data)=>{
            if(data?.status === true){
                // if(data?.result?.read_info){
                //     if(data?.result?.paging?.current_page === 1){
                //         setReadInfo(data?.result?.read_info);
                //     }
                // }
                setInfo(data?.result?.info);
                setName(data?.result?.name);
                return;
            }
            if(data?.code_msg === "empty_cnt_data"){
                setIsEmpty(true);
                return;
            }
            navigate(-1);
        },
        bottomRef:contentRef,
    })

    useEffect(()=>{
        if(isMobile){
            document.body.style.background = "";
            return;
        }
        document.body.style.background = "#f7f5f5";
        return ()=>{
            document.body.style.background = "";
        }
    },[isMobile]);

    useEffect(()=>{
        dataSubmit();
    },[]);


    if(data === null && isEmpty === false){
        return <></>
    }


    return (
        <>
            <Header useMobile={false} />

            <div id="container" className={style['container']} style={{paddingBottom:"0px"}}>
                <section className={"section detail_box wrapper clearfix template temp_list template_column " + style['section'] + " " + style['wrapper'] + " " + style['detail_box'] + " " + style['temp_list']}>
                    <div className={"radius-xxl color-bg-01 area_box " + style['area_box']}>
                    <div id="top_header" className={"color-bg-01 " + style['top_header']}>
                        <button 
                            type="button" 
                            className="prev_btn" 
                            onClick={()=>{
                                navigate(-1);
                            }}
                            ></button>
                        <span className="title-02-b color-txt-normal text_overflow">작가소개</span>
                    </div>
                    <div className={"content_body author_box " + style['content_body'] + " " + style['author_box']}>
                        <div className={"author_info " + style['author_info']}>
                            <div className={"info_txt " + style['info_txt']}>
                                <p className={"title-sub-02-b color-txt-muted "}>필명</p>
                                <p className="writer title-02-m-long color-txt-normal">{name}</p>
                            </div>
                        </div>
                        <div className={"status_info " + style['status_info']}>
                            <div className={"top_con " + style['top_con']}>
                                <div className={"left text_overflow " + style['left']}>
                                    <span className="color-txt-normal title-01-b">작품 현황</span>
                                </div>
                                <div className="right">
                                    <span className="btn-03 color-btn-03-txt">전체 작품 ({info?.total_cnt ?? 0})</span>
                                </div>
                            </div>
                            <div className={"radius-sm gold_opacity-10 status_box clearfix " + style['status_box']}>
                                <div className="left color-border-thumbnail border-right-line border-soild">
                                    <p>
                                        <span className={"title-01-m color-txt-04 stit " + style['stit']}>로맨스</span>
                                        <span className={"title-01-m color-txt-normal num " + style['num']}>{info?.romance ?? 0}</span>
                                    </p>
                                    <p>
                                        <span className={"title-01-m color-txt-04 stit " + style['stit']}>로맨스판타지</span>
                                        <span className={"title-01-m color-txt-normal num " + style['num']}>{info?.romancefantasy ?? 0}</span>
                                    </p>
                                </div>
                                <div className="right">
                                    <p>
                                        <span className={"title-01-m color-txt-04 stit " + style['stit']}>판타지</span>
                                        <span className={"title-01-m color-txt-normal num " + style['num']}>{info?.fantasy ?? 0}</span>
                                    </p>
                                    <p>
                                        <span className={"title-01-m color-txt-04 stit " + style['stit']}>BL</span>
                                        <span className={"title-01-m color-txt-normal num " + style['num']}>{info?.bl ?? 0}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className={"author_list " + style['author_list']}>
                            <div className={"top_con " + style['top_con']}>
                                <div className="left text_overflow">
                                    <p className={"writer_name color-txt-normal title-01-b " + style['writer_name']}>
                                        [<span className="text_overflow">{name}</span>] 작품
                                    </p>
                                </div>
                            </div>
                            <div className="list" ref={contentRef}>
                                {!isEmpty ? 
                                    <>
                                        <ul>
                                            {data?.map((item, index)=>{
                                                return (
                                                    <li className="clearfix" key={"list_"+index}>
                                                        <BookpalLink 
                                                            to={"/content/"+item?.ct_type+"/"+item?.bid}
                                                            check={{
                                                                view_type:memberInfo?.view_type,
                                                                work_adult:item?.adult,
                                                            }}
                                                            alert={alert}
                                                            >
                                                            <div className={"cover_img radius-xs " + style['cover_img']} >
                                                                {item?.adult ? <p className="ic_adult badge_adult_middle"><img src="../images/ic_adult.svg" /></p> : null}
                                                                <BookpalLazyLoadImage 
                                                                    adult={item?.adult}
                                                                    adultswitch={memberInfo?.audit_switch}
                                                                    defaulttype={"cover_logo"}
                                                                    locktype={"cover_lock"}
                                                                    src={item?.cover}
                                                                    // style={defaultImageStyle}
                                                                    className={style['cover_img']}
                                                                />
                                                                <p className="ic_bottom badges_box">
                                                                    {item?.badge_promotion !== "" ? <span className="ic_midnight radius-xs icon_badge"><img src={ImgBadge(item?.badge_promotion)} /></span> : null}
                                                                    {/* {item?.badge_new_up !== "" ? <span className="ic_up radius-xs icon_badge"><img src={ImgBadge(item?.badge_new_up)} /></span> : null} */}
                                                                    {item?.badge_discount > 0 ? <span className="ic_discount radius-xs discount_10 icon_badge"><img src={ImgBadge(item?.badge_discount)} /></span> : null }
                                                                </p>
                                                            </div>
                                                            <div className="info_txt spacing_08">
                                                                <div className="info">
                                                                    <span className="free body-01 color-txt-05">{item?.genre_kor}</span>
                                                                    {item?.free_chapter > 0 ? <span className="free body-01 color-txt-05">{item?.free_chapter}화무료</span> : null}
                                                                    <span className="view body-01 color-txt-05">{getViewCntConvert(item?.view_cnt)}</span>
                                                                </div>
                                                                <div className="list_tit_con">
                                                                    {item?.badge_new_up !== "" ? <span className="ic_up radius-xs icon_badge"><img src={ImgBadge(item?.badge_new_up)} /></span> : null}
                                                                    <span className="title color-txt-normal title-book-03-m text_overflow">{item?.title}</span>
                                                                </div>
                                                                {/* <div className="writer color-txt-03 body-02 text_overflow">{item?.wr_nick}</div> */}
                                                                <div className="keyword color-txt-04 btn-02 text_overflow">
                                                                    {/* <!-- span 태그 무조건 한줄에서 쓰기 --> */}
                                                                    {Array.isArray(item?.subject_array) ? 
                                                                        item?.subject_array.map((v, k)=>{
                                                                            return <span key={v+"_"+k}>#{v}</span>
                                                                        })
                                                                    :null}
                                                                    {/* <span>#키워드</span><span>#키워드</span><span>#키워드입니다~</span><span>#키워드</span><span>#키워드 들어가는자리</span><span>#키워드입니다~</span> */}
                                                                </div>
                                                            </div>
                                                        </BookpalLink>
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </>
                                :<>
                                    <p className={"no_data color-txt-04 body-02-long " + (!isMobile ? "large":"")}>등록된 작품이 없습니다.</p> 
                                </>}
                            </div>
                        </div>
                    </div>
                    </div>
                </section>
            </div>

            <Footer style={{display:"block"}} />
            <TopBtn />
        </>
    );
}




export default ContentsWriter;